import React, { useState } from "react";

import Select, { components } from "react-select";
import { FaAngleDown } from "react-icons/fa";

const MultiSelectWithCheckbox = ({ options, onChange,placeholder,selectedValues}) => {
  const [selectedOptions, setSelectedOptions] = useState(selectedValues || []);

  // Handle change when checkboxes are selected
  const handleSelectionChange = (selected) => {
    console.log("Selected options:", selected);
    setSelectedOptions(selected || []); // Update state
    // Map selected values to their IDs and pass them to the parent
    const selectedIds = (selected || []).map((option) => option.value);
    const selectedNames = (selected || []).map((option) => option.label);
    onChange( {selectedIds, selectedNames} ); // Return IDs 
  };
  

  // Custom rendering for options with checkboxes
  const customOption = ({ data, innerRef, innerProps }) => (
    <div ref={innerRef} {...innerProps} style={{ display: "flex", alignItems: "center", padding: "5px 10px", cursor: "pointer" }}>
      <input
        type="checkbox"
        checked={selectedOptions.some((option) => option.value === data.value)}
        readOnly
        style={{ marginRight: "10px" }}
      />
      {data.label}
    </div>
  );

  // Custom dropdown indicator
  // const DropdownIndicator = (props) => {
  //   return (
  //     <components.DropdownIndicator {...props}>
  //       <FaAngleDown />
  //     </components.DropdownIndicator>
  //   );
  // };

  const DropdownIndicator = (
    props
  ) => {
    return (
      <components.DropdownIndicator {...props}>
       <span class=" pointer-events-none"><svg className="" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" strokeWidth="2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round"></path></svg></span>
      </components.DropdownIndicator>
    );
  };

  // Define the styles and behavior for the select box
  const customComponents = {
    Option: customOption,
    DropdownIndicator,
    IndicatorSeparator: () => null, 
  };

  return (
    <Select
      options={options}
      classNamePrefix={"multi-react-select"}
      components={customComponents}
      isMulti
      value={selectedOptions}
      onChange={handleSelectionChange}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      placeholder={placeholder}
      className="text-sm rounded-lg w-full flex items-center justify-between border border-blue-100 multi-react-select"
    />
  );
};

export default MultiSelectWithCheckbox;
